export const homeResources = {
    en: {
        HeroHeadline: "Transform Your Finance Function Into a Strategic Advantage",
        HeroSubheadline: "Outsource financial operations, unlock real-time insights, and gain CFO-level leadership—without the overhead.",
        PrimaryCTA: "Book a Free Consultation →",
        SecondaryCTA: "Explore Our Services →",
        HeroImageDescription: "Executive team + digital finance dashboard overlay.",

        ValuePropTitle: "Our Value Proposition",
        ValuePropTitle1: "Financial BPO",
        ValuePropDesc1: "Streamline accounting, AP/AR, payroll, and reporting with reliable, scalable finance operations.",
        ValuePropTitle2: "FP&A Outsourcing",
        ValuePropDesc2: "Get budgeting, forecasting, dashboards, analytics, and scenario modeling—built to support data-driven decisions.",
        ValuePropTitle3: "Fractional CFO",
        ValuePropDesc3: "Access experienced finance leadership to guide growth, capital strategy, fundraising, and business transformation.",

        WhyChooseUsTitle: "Why Choose Us",
        WhyChooseUsDesc1: "Expert Finance Team – CFOs, controllers, FP&A analysts.",
        WhyChooseUsDesc2: "Advanced Tools – Power BI, Tableau, Netsuite, Anaplan, QuickBooks.",
        WhyChooseUsDesc3: "Cost-Effective – 40–60% lower than in-house teams.",
        WhyChooseUsDesc4: "Scalable – Support for startups to mid-market enterprises.",

        Callout: "We convert finance into a competitive advantage—giving leaders a clear view of performance, more control, and better decisions.",
        LearnMore: "Learn More →"
    },
    ar: {
        Welcome: "أهلا في موقعنا.",
        HeroHeadline: "حوّل وظيفة التمويل الخاصة بك إلى ميزة استراتيجية",
        HeroSubheadline: "استعن بمصادر خارجية للعمليات المالية، وافتح رؤى في الوقت الفعلي، واحصل على قيادة مالية بمستوى المدير المالي التنفيذي — بدون أي أعباء إضافية.",
        PrimaryCTA: "→ احجز استشارة مجانية",
        SecondaryCTA: "→ استكشف خدماتنا",
        HeroImageDescription: "فريق تنفيذي + لوحة بيانات مالية رقمية.",

        ValuePropTitle: "قيمتنا المقترحة",
        ValuePropTitle1: "الخدمات المالية (BPO)",
        ValuePropDesc1: "تبسيط المحاسبة، الحسابات الدائنة والمدينة، الرواتب، والتقارير مع عمليات مالية موثوقة وقابلة للتوسع.",
        ValuePropTitle2: "التحليل المالي والتخطيط (FP&A)",
        ValuePropDesc2: "الحصول على الميزانيات، التوقعات، لوحات البيانات، التحليلات، ونماذج السيناريوهات — لدعم اتخاذ القرارات المبنية على البيانات.",
        ValuePropTitle3: "المدير المالي الجزئي (Fractional CFO)",
        ValuePropDesc3: "الوصول إلى قيادة مالية ذات خبرة لتوجيه النمو، واستراتيجية رأس المال، وجمع التمويل، وتحويل الأعمال.",

        WhyChooseUsTitle: "لماذا تختارنا",
        WhyChooseUsDesc1: "فريق مالي خبير – مديرون ماليون، محاسبون، محللو FP&A.",
        WhyChooseUsDesc2: "أدوات متقدمة – Power BI، Tableau، Netsuite، Anaplan، QuickBooks.",
        WhyChooseUsDesc3: "فعّال من حيث التكلفة – أقل بنسبة 40–60٪ مقارنة بالفرق الداخلية.",
        WhyChooseUsDesc4: "قابل للتوسع – دعم للشركات الناشئة وحتى الشركات المتوسطة.",

        Callout: "نحوّل التمويل إلى ميزة تنافسية — مما يمنح القادة رؤية واضحة للأداء، مزيدًا من السيطرة، وقرارات أفضل.",
        LearnMore: "→ تعرف على المزيد"
    }
}
